module.exports = __webpack_public_path__ + "img/19.66ebd5a9.jpg";